<template>
	<span class="editable-span" :class="{'right-aligned':rightAligned,'multi-line':multiLine,minimal}">
		<span v-if="multiLine" class="editable_text no-drag" contenteditable="true"
		      @blur="save"
		      @input="input"
		      v-text="localValue" :key="'editable_span_'+id" :ref="'editable_span_'+id">
		</span>
		<span v-else class="editable_text no-drag" contenteditable="true"
		      @blur="save"
		      @input="input"
		      @keydown.enter.prevent
		      v-text="localValue" :key="'editable_span_'+id" :ref="'editable_span_'+id">
		</span>

		<span class="__save-icon" @click.p.prevent="save" v-if="changed">
			<inline-svg :src="require('@/assets/img/check-bold.svg')" />
		</span>
	</span>

</template>

<script>
let id = 1;
export default {
	name: "editable-span",
	props: {
		value:{
			type: String,
			default:"",
		},
		rightAligned:{
			type: Boolean,
			default:false,
		},
		multiLine:{
			type: Boolean,
			default:false,
		},
		minimal:{
			type: Boolean,
			default:false,
		},
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	data() {
		return {
			id: id++,
			localValue: this.value,
			changed:false,
		}
	},
	watch:{
		value() {
			this.localValue = this.value;
		}
	},
	computed:{
	},
	methods:{
		input(e) {

			this.changed = true;
		},
		save(){
			let v = this.$refs['editable_span_'+this.id];
			this.$emit('input', v.innerText);
			this.changed = false;
		}
	},
	created() {
		this.localValue = this.value;

	}
}
</script>

<style lang="scss" scoped>
.editable-span {
	display: flex;
	flex-direction: row;
	position: relative;
	height: fit-content;
	pointer-events: all;

	&.minimal {
		.editable_text {
			min-width: 5px;
		}
	}
	&.multi-line {

	}
	&.right-aligned {
		> span {
			text-align: right;
		}
		.__save-icon {
			left: -25px;
			margin-left: 0;
		}
	}
	&:not(.right-aligned) {
		.__save-icon {
			right: -25px;
		}
	}
	.__save-icon {
		pointer-events: all;
		cursor: pointer;
		background: $dark-grey;
		color: white;
		border-radius: 15px;
		padding: 2px;
		margin-left: 5px;
		width: 20px;
		height: 20px;
		position: absolute;
		z-index: 5;

		&:hover{
			background: $darker-grey;
		}
		svg {
			color: white;
			width: fit-content;
			height: fit-content;
		}
	}
}
</style>
